import { computed } from 'vue';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import { usePkvInputStore } from '@/features/Sparten/pkv/useInputStore';
import { VERSICHERUNGSART } from '@/features/Sparten/shared/types';
import { usePkvPreviousInsuranceStore } from '@/features/Sparten/pkv/usePreviouseInsuranceInputStore';
import { PKV_PREVIOUS_INSURANCE_TYPE } from '@/features/Sparten/pkv/schema/previousInsuranceSchema/previousInsuranceSchema';

export const isBeamter = () =>
  getSimpleChoiceMeta(
    SIMPLE_CHOICE.PROFESSION,
    SIMPLE_CHOICE_META.IS_BEAMTER,
  ).includes(usePkvInputStore().berufsgruppe);

export const isBeamterReactive = computed(() =>
  getSimpleChoiceMeta(
    SIMPLE_CHOICE.PROFESSION,
    SIMPLE_CHOICE_META.IS_BEAMTER,
  ).includes(usePkvInputStore().berufsgruppe),
);

export const isStudent = () =>
  getSimpleChoiceMeta(
    SIMPLE_CHOICE.PROFESSION,
    SIMPLE_CHOICE_META.BERUFSGRUPPE_IS_STUDENT,
  ).includes(usePkvInputStore().berufsgruppe);

export const isStudentReactive = computed(() => isStudent());

export const isArbeitnehmer = () =>
  getSimpleChoiceMeta(
    SIMPLE_CHOICE.BERUFSSTATUS,
    SIMPLE_CHOICE_META.IS_ARBEITNEHMER,
  ).includes(usePkvInputStore().berufsgruppe);

export const isArbeitnehmerReactive = computed((): boolean => isArbeitnehmer());

export const hideBerufsstatus = computed(() =>
  getSimpleChoiceMeta(
    SIMPLE_CHOICE.BERUFSSTATUS,
    SIMPLE_CHOICE_META.BERUFSSTATUS_HIDE_BERUFSSTATUS,
  ).includes(usePkvInputStore().berufsgruppe),
);

export const hasAmbulantSelected = () => usePkvInputStore().ambulant;

export const hasAmbulantSelectedReactive = computed(() =>
  hasAmbulantSelected(),
);

export const hasAmbulantNotSelected = computed(
  () => !usePkvInputStore().ambulant,
);

export const hasZahnSelected = () => usePkvInputStore().zahn;

export const hasZahnSelectedReactive = computed(() => hasZahnSelected());
export const hasZahnNotSelected = computed(() => !usePkvInputStore().zahn);

export const hasKrankentagegeldSelected = () =>
  usePkvInputStore().krankentagegeld;

export const hasKrankentagegeldSelectedReactive = computed(() =>
  hasKrankentagegeldSelected(),
);

export const hasKrankentagegeldNotSelected = computed(
  () => !usePkvInputStore().krankentagegeld,
);

export const hasKrankenhaustagegeldSelected = () =>
  usePkvInputStore().krankenhaustagegeld;

export const hasKrankenhaustagegeldSelectedReactive = computed(() =>
  hasKrankenhaustagegeldSelected(),
);

export const hasKrankenhaustagegeldNotSelected = computed(
  () => !usePkvInputStore().krankenhaustagegeld,
);

export const hasAuslandsreisekrankenversicherungSelected = computed(
  () => usePkvInputStore().auslandsreisekrankenversicherung,
);
export const hasAuslandsreisekrankenversicherungNotSelected = computed(
  () => !usePkvInputStore().auslandsreisekrankenversicherung,
);

export const hasPflegepflichtVersicherungSelected = computed(
  () => usePkvInputStore().pflegepflichtversicherung,
);
export const hasPflegepflichtVersicherungNotSelected = computed(
  () => !usePkvInputStore().pflegepflichtversicherung,
);

export const hasStationaerSelected = computed(
  () => usePkvInputStore().stationaer,
);
export const hasStationaerNotSelected = computed(
  () => !usePkvInputStore().stationaer,
);

export const hasPflegezusatzNotSelected = computed(
  () => !usePkvInputStore().pflegezusatz,
);
export const hasPflegezusatzSelected = computed(
  () => usePkvInputStore().pflegezusatz,
);

export const hasPreviousInsuranceSelected = computed(
  () => usePkvPreviousInsuranceStore().aktiv,
);

export const hasPrivatPreviousInsurance = computed(
  () =>
    usePkvPreviousInsuranceStore().art === PKV_PREVIOUS_INSURANCE_TYPE.PRIVATE,
);

export const hasPreviousInsuranceCompanySelected = computed(
  () => usePkvPreviousInsuranceStore().gesellschaft !== 0,
);

export const isVollversicherung = computed(
  () => usePkvInputStore().versicherungsart === VERSICHERUNGSART.VOLL,
);

export const isZusatzversicherung = computed(() => !isVollversicherung.value);

export const withAGAnteil = computed(() => {
  if (isZusatzversicherung.value) {
    return false;
  }

  let isWithAGAnteil =
    usePkvPreviousInsuranceStore().berufsgruppe === ''
      ? false
      : !getSimpleChoiceMeta(
          SIMPLE_CHOICE.PROFESSION,
          SIMPLE_CHOICE_META.BERUFSGRUPPE_HIDE_AG_ANTEIL,
        ).includes(usePkvPreviousInsuranceStore().berufsgruppe);

  if (
    getSimpleChoiceMeta(
      SIMPLE_CHOICE.PROFESSION,
      SIMPLE_CHOICE_META.BERUFSGRUPPE_HIDE_AG_ANTEIL_WITHOUT_ARBEITNEHMER,
    ).includes(usePkvPreviousInsuranceStore().berufsgruppe) &&
    !getSimpleChoiceMeta(
      SIMPLE_CHOICE.BERUFSSTATUS,
      SIMPLE_CHOICE_META.IS_ARBEITNEHMER,
    ).includes(usePkvPreviousInsuranceStore().berufsstatus)
  ) {
    isWithAGAnteil = false;
  }

  return isWithAGAnteil;
});

export const hasPreviousInsuranceWithAGAnteil = computed(
  () =>
    usePkvPreviousInsuranceStore().art === PKV_PREVIOUS_INSURANCE_TYPE.PUBLIC ||
    withAGAnteil.value,
);
